import {
  AMPERSANDIST_PRODUCTS,
  BundleProduct,
  isBundleProduct,
} from "../lib/models/Products";

import { toTitleCase } from "../util/strings";

const allStyles = [
  "Regular",
  "Medium",
  "SemiBold",
  "Bold",
  "ExtraBold",
  "Black",
  "ExtraBlack",
];

const textFontFamily = "ST Ampersandist Regular";

const Ampersandist = {
  name: "Ampersandist",
  subtitle: "Earthy and bold.",
  accentColor: "mint",
  secondaryAccentColor: "blue",
  fineTextColor: "fedblue",
  defaultStyle: "Ampersandist Regular",
  styleGroups: [
    {
      name: "Ampersandist",
      fontStyles: AMPERSANDIST_PRODUCTS.filter((product) =>
        [32, 33, 34, 35, 36, 37, 38].includes(product.id)
      ),
    },
  ],
  stylePurchaseBundles: AMPERSANDIST_PRODUCTS.filter(
    isBundleProduct
  ) as BundleProduct[],
  textFontFamily,
  headerFontFamily: "ST Ampersandist Bold",
  specimenRows: [
    "Mae Jemison",
    "Kalpana Chawla",
    "José Hernandez",
    "Ellen Ochoa",
    "Guion S. Bluford",
    "Chawla Koichi",
    "Another Name",
  ].map((name, i) => {
    return {
      fontName: `Ampersandist ${toTitleCase(allStyles[i])}`,
      fontFamily: `ST Ampersandist ${allStyles[i]}`,
      fontText: name,
      group: "Ampersandist",
    };
  }),
  info: {
    description: (
      <>
        <p style={{ fontFamily: textFontFamily }}>
          Inspired by earthy bold calligraphic forms, this typeface has a
          headstrong character. Its strong clear-cut forms give a friendly yet
          opinionated voice about what it’s saying. Currently in its early
          stages, this family contains 3 weights in the upright roman character
          set that supports barebones Latin (A-Z, a-z, and basic punctuation).
        </p>
        <p style={{ fontFamily: textFontFamily }}>
          The finished family is expected to be four weights in both upright and
          italic, bringing it to be eight styles.
        </p>
      </>
    ),
    languagesSupported:
      "Albanian, Asu, Basque, Bemba, Bena, Breton, Catalan, Chiga, Colognian, Cornish, Croatian, Czech, Danish, Dutch, English, Estonian, Faroese, Filipino, Finnish, French, Friulian, Galician, Ganda, German, Gusii, Hungarian, Inari, Sami, Indonesian, Irish, Italian, Jola-Fonyi, Kabuverdianu, Kalenjin, Kinyarwanda, Koyra, ChiiniLatvian, Koyraboro, Senni, Lithuanian, Lower Sorbian, LuoLuxembourgish, Luyia, Machame, Makhuwa-Meetto, Makonde, Malagasy, Maltese, Manx, Marshallese, Moldavian, Morisyen, North Ndebele, Northern Sami, Norwegian Bokmål, Norwegian,  Nynorsk, Nyankole, Oromo, Polish, Portuguese, Quechua, Romanian, Romansh, Rombo, Rundi, Rwa, Samburu, Sango, Sangu, Scottish, Gaelic, Sena, Serbian, Shambala, Shona, Slovak, Soga, Somali, Spanish, Swahili, Swedish, Swiss, German, Taita, Tasawaq, Teso, Turkish, Upper Sorbian, Uzbek (Latin), Volapük, VunjoWalser, Welsh, Western Frisian, Zarma, Zulu.",
    collection: "ST Ampersandist",
    designers: "Lynne Yun",
    release: "2025",
    numWeights: 7,
    numStyles: 14,
    version: "1.0",
    fileFormats: ".otf, .ttf, .woff2",
  },
};

export default Ampersandist;
